import { Directive } from '@angular/core';

@Directive({
  selector: '[noDataTemplate]',
  standalone: true,
})
export class NoDataTemplateDirective {}
